define([
	'jquery',
    'pubsub'
], function($, pubsub) {

    var PLUGIN_IDENTIFIER = "productSnapshot";
    var DEBUG = false;

    var vfdpPlugin = function(element, options) {
        this.element = element;
        this.options = options;
    };

    vfdpPlugin.prototype = {
        defaults: {
            speed: 30,
            distance: null,
            step: null,
            rightScrollBtnSelector: '.product-snapshot-scroll-right-btn',
            leftScrollBtnSelector: '.product-snapshot-scroll-left-btn',
            scrollableContainer: '.product-snapshot-container',
            scrollableContainerItems: '.product-snapshot-item-wrapper'
        },

        init : function () {
            var self = this;

            if ( DEBUG ) console.debug('Initializing ', PLUGIN_IDENTIFIER, 'on', $(self.element));

            // Merge various methods of providing plugin options into a single config object
            self.metadata = $(self.element).data(PLUGIN_IDENTIFIER+'Options');
            self.config = $.extend(
                {}, // empty object to merge into
                self.defaults, // defaults hardcoded into the prototype defined in this file
                self.options, // options provided when initializing by JQuery $(selector).myPlugin(options)
                self.metadata // options provided as HTML data attribute $(selector).data()
            );

            // Hide the buttons if the container doesnt have a scrollbar
            $(self.config.leftScrollBtnSelector).addClass('hidden');
            if ($(self.config.scrollableContainer).scrollLeft() + $(self.config.scrollableContainer).outerWidth() >= $(self.config.scrollableContainer)[0].scrollWidth) {
                $(self.config.rightScrollBtnSelector).addClass('hidden');
            }

            // Calculate the scroll distance based on the item width
            if (self.config.distance == null) {
                self.config.distance = $(self.config.scrollableContainerItems).eq(0).outerWidth(true);
            }

            // Calculate the step for the each scroll based on distance / 5
            if (self.config.step == null) {
                self.config.step = self.config.distance / 5;
            }

            self.populateProductSnapshotText();
            self.events();

            // Allow JQuery-style chaining of the plugin
            return self;
        },

        /**
         * Binds plugin events
         **/
        events: function() {
            var self = this;

            $.pubsub('subscribe', 'vfdp.wcs.product_reviews.loaded', function () {
                self.populateProductSnapshotText();
            });

            $(self.config.rightScrollBtnSelector).on('click', function () {
                self.handleScrollClick($(self.config.scrollableContainer), 'right', self.config.speed, self.config.distance, self.config.step);
            });

            $(self.config.leftScrollBtnSelector).on('click', function () {
                self.handleScrollClick($(self.config.scrollableContainer), 'left', self.config.speed, self.config.distance, self.config.step);
            });

            $(self.config.scrollableContainer).on('touchend', function() {
                self.updatePrevNextButtons($(this));
            });
        },

        populateProductSnapshotText: function () {
            var snapshotPercent = $('.pr-reco-value'),
                snapshotBlock = $('.product-snapshot-item-wrapper:last-child');

            // Check if we have a snapshot percent to avoid showing the snaptshot bar when we don't have one
            if (snapshotPercent.length && !isNaN(parseInt(snapshotPercent.text(), 10))) {
                // Show the recommended % if we can
                $('.product-snapshot-item-recommendation-container .percentage').html(parseInt(snapshotPercent.text(), 10));
                snapshotBlock.removeClass('hide');
            }
        },

        handleScrollClick: function (element, direction, speed, distance, step) {
            var self = this;
            var scrollAmount = 0;

            var slideTimer = setInterval(function () {
                if (direction === 'left') {
                    element.scrollLeft(element.scrollLeft() - step);
                } else {
                    element.scrollLeft(element.scrollLeft() + step);
                }
                scrollAmount += step;
                if (scrollAmount >= distance) {
                    window.clearInterval(slideTimer);
                    self.updatePrevNextButtons(element);
                }
            }, speed);
        },

        updatePrevNextButtons: function(element) {
            var self = this;

            if (Math.floor(element.scrollLeft()) >= Math.floor(element[0].scrollWidth - element.outerWidth())) {
                $(self.config.rightScrollBtnSelector).addClass('hidden');
            } else {
                $(self.config.rightScrollBtnSelector).removeClass('hidden');
            }
            if (element.scrollLeft() !== 0) {
                $(self.config.leftScrollBtnSelector).removeClass('hidden');
            } else {
                $(self.config.leftScrollBtnSelector).addClass('hidden');
            }
        }
    };

    // Create the instance defaults from the prototype
    vfdpPlugin.defaults = vfdpPlugin.prototype.defaults;

    // Register as a JQuery plugin and prevent duplicate instantiation
    $.fn[PLUGIN_IDENTIFIER] = function(options) {
        return this.each(function() {
            var instance = $(this).data(PLUGIN_IDENTIFIER);
            if(!instance) {
                instance = new vfdpPlugin(this, options).init();
                $(this).data(PLUGIN_IDENTIFIER, instance);
            }
        });
    };
});
